import { slotDefinition as defaultSlotDefinition } from "../configs/slotDefinition.config.js";
import { SpinResultMapper } from "./SpinResultMapper.js";

export class AnubisGameLogic {
    constructor({ api, slotDefinition = defaultSlotDefinition }) {
        this._api = api;
        this._resultMapper = new SpinResultMapper({ slotDefinition });

        this._balance = 1000;
        this._bet = 0.5;
        this._totalWin = 0;
    }

    get balance() { return this._balance; }
    get bet() { return this._bet; }
    get totalWin() { return this._totalWin; }

    canBet() { return this._balance >= this._bet; }

    async setBet(value) {
        this._bet = value;
        return { bet_sum: value };
    }

    async spin() {
        this._balance -= this._bet;

        const params = { bet: this._bet, balance: this._balance };
        const data = await this._api.spin(params);
        const result = this._resultMapper.parse(data, { bet: this._bet });
        this._balance = result.balance;
        this._totalWin = result.win;
        return result;
    }
}
